
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import { IJourney } from "@interfaces/IJourney";
import { IPlot, IPlotEvent } from "@interfaces/IPlot";
import { IVehicle } from "@interfaces/IVehicle";
import { GoogleMarkerService, ICreateEventMarkerOptions } from "@services/googleMarker.service";
import { JourneyService } from "@services/journey.service";
import { MapService } from "@services/map.service";
import { PlotService } from "@services/plot.service";
import { PlotEventService } from "@services/plotEvent.service";
import { TranslationService } from "@services/translation.service";
import { IPolyline } from "@typings/google.maps.angular";
import { AccountFeatureService, UserRole } from "@services/accountFeature.service";

@Component({
    selector: "veri-map-current-journey",
    template: require("./veriMapCurrentJourney.html")
})
export class VeriMapCurrentJourneyComponent implements OnInit, OnChanges, OnDestroy {

    @Input() vehicle: IVehicle;
    @Input() vehiclePlot: IPlot;

    //[x: string]: any;
    veriMap: IVeriMapComponent;

    journey: IJourney;
    journeyStart: IPlotEvent;
    showJourneyStart = false;

    journeyStartMarker: IGoogleMapsMarker;
    journeyPolyline: IPolyline;

    mapIdleListener: google.maps.MapsEventListener;

    fit: boolean;

    constructor(
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly plotService: PlotService,
        private readonly plotEventService: PlotEventService,
        private readonly journeyService: JourneyService,
        private readonly accountFeatureService: AccountFeatureService,
        private readonly mapService: MapService,
        private readonly googleMarkerService: GoogleMarkerService,
        private readonly translationService: TranslationService) {
    }

    ngOnChanges(onChangesObj: SimpleChanges): void {
        if (onChangesObj["vehicle"]) {
            this.vehicleChanged();
        }

        if (onChangesObj["vehiclePlot"]) {
            this.vehiclePlotChanged();
        }
    }

    ngOnInit(): void {
        this.veriMap = this.mapService.findVeriMap(this.elementRef);
        this.veriMap.mapInitialisedPromise.then(map => {
            this.mapIdleListener = map.addListener("idle", () => {
                this.showHideJourneyStart();
                this.createJourneyMarker();
            });
        });
    }

    ngOnDestroy() {
        if (this.mapIdleListener) {
            this.mapIdleListener.remove();
        }
    }

    // -------------------------------

    private createJourneyMarker() {
        const options: ICreateEventMarkerOptions = {
            label: this.translationService.t('veriMapCurrentJourney.journeyStart'),
            position: {
                lat: this.journey?.StartLatitude,
                lng: this.journey?.StartLongitude
            }
        }

        this.journeyStartMarker = {
            id: 1,
            options: this.googleMarkerService.createEventMarkerOptions(options)
        }
    }

    private vehicleChanged() {
        if (!this.vehicle) {
            return;
        }

        this.journeyPolyline = null;
        this.journeyStart = null;

        this.getCurrentJourneyWithPlots(this.vehicle.Id);
    }

    private vehiclePlotChanged() {
        //console.log("vehiclePlotChanged", this.journey ? this.journey.plots : "no journey yet");
        if (!this.vehiclePlot || !this.journeyPolyline || !this.journey) {
            return;
        }

        if (!this.journey.plots) {
            this.journey.plots = [];
        }

        this.journey.plots.push(this.vehiclePlot);
        //console.log("vehiclePlotChanged.1", this.journey.plots);

        this.journeyPolyline = this.journeyService.createJourneyPolyline(this.journey);
    }

    private getCurrentJourneyWithPlots(vehicleId: number): void{
        if (!this.accountFeatureService.currentUserHasRole([UserRole.History])) {
            return;
        }
        this.journeyService
            .getCurrentJourney(vehicleId)
            .then(journey => {

                this.journey = journey;

                if (journey) {
                    return this.getAndMapPlotsForJourney(vehicleId, this.journey);
                }
            });
    }

    private getAndMapPlotsForJourney(vehicleId: number, journey: IJourney) {

        return this.plotService
            .getPlotsForJourney(vehicleId, journey)
            .then(plots => {

                // Remove any plots that are newer than the current vehicle position
                if (this.vehiclePlot && plots[plots.length - 1].Id > this.vehiclePlot.Id) {
                    plots.pop();
                }

                journey.plots = plots;
                if (journey.plots.length > 1) {
                    this.journeyStart = this.plotEventService.createJourneyStartStopEvent(journey.plots[0], this.translationService.t("veriMapCurrentJourney.start") as any);
                }

                this.journeyPolyline = this.journeyService.createJourneyPolyline(journey);
                this.showHideJourneyStart();
            });
    }

    private showHideJourneyStart() {
        if (this.journeyPolyline == null || this.veriMap.getMap() == null) {
            return;
        }

        // get the extend of our journey and check how far apart it is in pixels, if its too small hide the start marker of our current journey
        var bounds = new google.maps.LatLngBounds();
        this.journeyPolyline.path.forEach(latlng => {
            bounds.extend(latlng);
        });

        var nePoint = this.mapService.convertLatLngToPoint(bounds.getNorthEast(), this.veriMap.getMap());
        var swPoint = this.mapService.convertLatLngToPoint(bounds.getSouthWest(), this.veriMap.getMap());

        var x = nePoint.x - swPoint.x;
        var y = nePoint.y - swPoint.y;

        var maxDifference = Math.max(x, y);
        this.showJourneyStart = maxDifference > 40;
    }
}
